export default interface Permission {
  _create?: boolean;
  _read?: boolean;
  _delete?: boolean;
  _edit?: boolean;
  id?: string
  authorized_fields?: string | null;
  __typename: 'Permission';
}

export const createDummyPermissions = (): Permission => ({
  _create: false,
  _edit: false,
  _read: false,
  _delete: false,
  authorized_fields: null,
  __typename: 'Permission',
});
